import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../Common/Sidebar";
import Loader from "../Common/Loader";
import { TabView, TabPanel } from "primereact/tabview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "react-bootstrap";
import CommonValues from "../Common/utils";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button as PrimeButton } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
type Employee = {
  departmentId: number | null; 
  employeeName: string;
  role: string;
  email: string;
  contactNo: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  about: string;
  skills: string;
};

export default function CDAdminLandingPage() {
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [offices, setOffices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [employees, setEmployees] = useState<Employee[]>([]);
  
  const [employeeFilters, setEmployeeFilters] = useState({
  name: '',
  departmentId: null,
  role: '',
  location: ''
 });

  const navigate = useNavigate();
  
  const defaultEmployeeForm = {
  departmentId: null,
  employeeName: "",
  role: "",
  address: "",
  state: "",
  city: "",
  zip: "",
  contactNo: "",
  email: "",
  about: "",
  skills: ""
};
const [employeeFormData, setEmployeeFormData] = useState<Employee>(defaultEmployeeForm);


  const onSidebarValueChanged = (value: any) => {
    setShowWideSidebar(value);
  };

  useEffect(() => {
    const token = CommonValues.GetToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const fetchEmployees = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/employee/get`,
          { headers }
        );
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.data || response.data?.employees || [];
        setEmployees(data);
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    const fetchDepartments = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/department/get`,
          { headers }
        );
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.data || response.data?.departments || [];
        setDepartments(data);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    const fetchOffices = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/office/get`,
          { headers }
        );
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.data || response.data?.offices || [];
        setOffices(data);
      } catch (error) {
        console.error("Error fetching offices:", error);
      }
    };

    const fetchAllData = async () => {
      setLoading(true);
      await fetchEmployees();
      await fetchDepartments();
      await fetchOffices();
      setLoading(false);
    };

    fetchAllData();
  }, []);

 const actionBodyTemplate = (rowData: any, type: any) => {
   return (
     <div className="d-flex gap-2">
       <button className="action-icon-btn icon-view" onClick={() => handleView(rowData, type)} title="View">
         <i className="pi pi-eye"></i>
       </button>
       <button className="action-icon-btn icon-edit" onClick={() => handleEdit(rowData)} title="Edit">
         <i className="pi pi-pen-to-square"></i>
       </button>
       <button className="action-icon-btn icon-delete" onClick={() => handleDelete(rowData, type)} title="Delete">
         <i className="pi pi-trash"></i>
       </button>
     </div>
   );
 };

const handleView = (rowData : any, type : any) => {
  };

const handleAddNewEmployee = () => {
  setEmployeeFormData(defaultEmployeeForm);
  setEditFormVisible(true);
};
const handleEdit = (rowData: any) => {
  setEmployeeFormData(rowData);
  setEditFormVisible(true);
};

const handleDelete = (rowData :any, type : any) => {
 };

const submitEmployeeForm = async (e : any) => {e.preventDefault(); 
  try {
    const token = CommonValues.GetToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    };
    const response = await axios.post(
      `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/employee/insert`,
      employeeFormData,
      { headers }
    );
    setEditFormVisible(false);
  } catch (error) {
  }
};

const locationOptions = Array.from(new Set(employees.map(emp => emp.state))).filter(Boolean).map(state => ({
  label: state,
  value: state
}));

const filteredEmployees: Employee[] = employees.filter((emp: Employee) => {
  return (
    (!employeeFilters.name || emp.employeeName?.toLowerCase().includes(employeeFilters.name.toLowerCase())) &&
    (!employeeFilters.role || emp.role?.toLowerCase().includes(employeeFilters.role.toLowerCase())) &&
    (!employeeFilters.location || emp.state?.toLowerCase().includes(employeeFilters.location.toLowerCase())) &&
    (!employeeFilters.departmentId || emp.departmentId === employeeFilters.departmentId)
  );
});

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename="admin"
        onSidebarValueChanged={onSidebarValueChanged}
      />
      <div className="flex-grow-1 d-flex flex-column bg-light p-2 mt-4">
        <div className={`${
            showWideSidebar
              ? "main-content-large-width"
              : "main-content-small-width"
          }`}
        >
          <div>
            <h2 className="fw-bold">Admin Dashboard</h2>
            <p className="text-muted">
             Manage your company directory and employee information
            </p>
          </div>

          <div className="card p-3">
            <div className="d-flex mt-4 mb-4 gap-4 dashboard-container">
              <div className="info-block dashboard-card shadow-hover p-3 rounded-4 w-100 d-flex align-items-center justify-content-between">
                <div>
                  <p className="dashboard-label mb-1">Total Employees</p>
                  <h2 className="dashboard-number mb-1">
                    {Array.isArray(employees) ? employees.length : 0}
                  </h2>
                  <p className="text-muted text-12 mb-0">+12 this month</p>
                </div>
                <i className="pi pi-users text-primary fs-1" />
              </div>

              <div className="info-block dashboard-card shadow-hover p-3 rounded-4 w-100 d-flex align-items-center justify-content-between">
                <div>
                  <p className="dashboard-label mb-1">Departments</p>
                  <h2 className="dashboard-number mb-1">
                    {Array.isArray(departments) ? departments.length : 0}
                  </h2>
                  <p className="text-muted text-12 mb-0">Active departments</p>
                </div>
                <i className="pi pi-building text-success fs-1" />
              </div>

              <div className="info-block dashboard-card shadow-hover p-3 rounded-4 w-100 d-flex align-items-center justify-content-between">
                <div>
                  <p className="dashboard-label mb-1">Office Locations</p>
                  <h2 className="dashboard-number mb-1">
                    {Array.isArray(offices) ? offices.length : 0}
                  </h2>
                  <p className="text-muted text-12 mb-0">Global presence</p>
                </div>
                <i className="pi pi-map-marker text-danger fs-1" />
              </div>
            </div>

            {loading ? (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
            ) : (
              <TabView className="mb-2 tabview-tab">
                <TabPanel header="Employees" className="mb-0 mt-0">
                  <div className="row p-1 d-flex align-items-end mb-3 mt-0">
                     <div className="col-md">
                       <label style={{ fontSize: "12px", color: "#381574" }}>Employee Name</label>
                         <InputText  className="cd-custom-inputbox" placeholder="Filter by Employee Name"value={employeeFilters.name}
                          onChange={(e) => setEmployeeFilters({ ...employeeFilters, name: e.target.value })} />
                     </div>
                     <div className="col-md">
                       <label style={{ fontSize: "12px", color: "#381574" }}>Department</label>
                          <Dropdown
                              placeholder="Filter by Department"
                              className="custom-dropdownbox"
                              value={employeeFilters.departmentId}              
                              options={departments}                           
                              optionLabel="departmentName"                     
                              optionValue="id"                                 
                              onChange={(e) => setEmployeeFilters({...employeeFilters, departmentId: e.value})} 
                              showClear                                 
                          />
                     </div>
                     <div className="col-md">
                       <label style={{ fontSize: "12px", color: "#381574" }}>Role</label>
                         <InputText className="cd-custom-inputbox" placeholder="Filter by Employee Role" />
                     </div>
                     <div className="col-md">
                       <label style={{ fontSize: "12px", color: "#381574" }}>Location</label>
                          <Dropdown
                            placeholder="Filter by Location"
                            className="custom-dropdownbox"
                            value={employeeFilters.location}
                            options={locationOptions}
                            onChange={(e) => setEmployeeFilters({...employeeFilters, location: e.value})}
                            showClear
                          />
                     </div>
                     <div className="col-md-auto d-flex align-items-end">
                       <Button  size="sm" className="fa fa-undo undo-btn" title="Clear filters" />
                     </div>
                     <div className="col-md-auto d-flex align-items-end">
                       <Button size="sm" style={{backgroundColor: "#3b0a69",fontSize: "14px",padding: "4px 8px",width: "auto",}}  onClick={handleAddNewEmployee}>
                         Add New Employee
                       </Button>
                     </div>
                  </div>
                  <DataTable
                    value={filteredEmployees}
                   className="support-call-table custom-bordered-datatable text-14"
                    emptyMessage="No employees found."
                    paginator rows={5}
                  >
                    <Column field="employeeName" header="Name" sortable />
                    <Column field="role" header="Role" />
                    <Column field="email" header="Email" />
                    <Column field="contactNo" header="Contact" />
                    <Column field="state" header="State" />
                    <Column  header="Actions" body={(rowData) => actionBodyTemplate(rowData, 'employee')}/>
                  </DataTable>
                </TabPanel>

                <TabPanel header="Departments">
                  <div className="row p-1 d-flex align-items-end mb-3 mt-0">
                     <div className="col-3">
                       <label style={{ fontSize: "12px", color: "#381574" }}>Department</label>
                          <Dropdown
                            placeholder="Filter by Department"
                            className="custom-dropdownbox"
                            value={employeeFilters.departmentId}              
                            options={departments}                           
                            optionLabel="departmentName"                     
                            optionValue="id"                                 
                            onChange={(e) => setEmployeeFilters({...employeeFilters, departmentId: e.value})} 
                            showClear
                          />
                     </div>
                     <div className="col-3">
                       <label style={{ fontSize: "12px", color: "#381574" }}>Location</label>
                          <Dropdown
                            placeholder="Filter by Location"
                            className="custom-dropdownbox"
                            value={employeeFilters.location}
                            options={locationOptions}
                            onChange={(e) => setEmployeeFilters({...employeeFilters, location: e.value})}
                            showClear
                          />
                     </div>
                     <div className="col-md-auto d-flex align-items-end">
                       <Button  size="sm" className="fa fa-undo undo-btn" title="Clear filters" />
                     </div>
                     <div className="col-md-auto d-flex align-items-end">
                       <Button size="sm" style={{backgroundColor: "#3b0a69",fontSize: "14px",padding: "4px 8px",width: "auto",}}>
                         Add New Department
                       </Button>
                     </div>
                  </div>
                  <DataTable
                    value={departments}
                   className="support-call-table custom-bordered-datatable text-14"
                    emptyMessage="No departments found."
                    paginator rows={5}
                  >
                    <Column field="departmentName" header="Name" sortable />
                    <Column field="description" header="Description" />
                    <Column field="city" header="City" />
                    <Column field="state" header="State" />
                    <Column field="contactNo" header="Contact" />
                    <Column  header="Actions" body={(rowData) => actionBodyTemplate(rowData, 'department')}/>
                  </DataTable>
                </TabPanel>

                <TabPanel header="Offices">
                  <div className="row p-1 d-flex align-items-end mb-3 mt-0">
                     <div className="col-3">
                       <label style={{ fontSize: "12px", color: "#381574" }}>Location</label>
                          <Dropdown
                            placeholder="Filter by Location"
                            className="custom-dropdownbox"
                            value={employeeFilters.location}
                            options={locationOptions}
                            onChange={(e) => setEmployeeFilters({...employeeFilters, location: e.value})}
                            showClear
                          />
                     </div>
                     <div className="col-md-auto d-flex align-items-end">
                       <Button  size="sm" className="fa fa-undo undo-btn" title="Clear filters" />
                     </div>
                     <div className="col-md-auto d-flex align-items-end">
                       <Button size="sm" style={{backgroundColor: "#3b0a69",fontSize: "14px",padding: "4px 8px",width: "auto",}}>
                         Add New Office
                       </Button>
                     </div>
                  </div>
                  <DataTable
                    value={offices}
                    className="support-call-table custom-bordered-datatable text-14"
                    emptyMessage="No offices found."
                    paginator rows={5}
                  >
                    <Column field="name" header="Office Name" sortable />
                    <Column field="address" header="Address" />
                    <Column field="city" header="City" />
                    <Column field="state" header="State" />
                    <Column field="zip" header="Zip Code" />
                    <Column field="contactNo" header="Contact" />
                    <Column  header="Actions" body={(rowData) => actionBodyTemplate(rowData, 'office')}/>
                  </DataTable>
                </TabPanel>
              </TabView>
            )}
          </div>
          <Dialog
             header="Edit Employee Details"
             visible={editFormVisible}
             onHide={() => setEditFormVisible(false)}
             style={{ width: "35vw", minHeight: "auto" }}
             className="text-14 styled-dialog"
             draggable={false}
          >
            <form className="p-fluid mt-3">
                {[
                  { label: "Employee Name", field: "employeeName", type: "text" },
                  { label: "Role", field: "role", type: "text" },
                  { label: "Email", field: "email", type: "text" },
                  { label: "Contact No", field: "contactNo", type: "text" },
                  { label: "Address", field: "address", type: "text" },
                  { label: "City", field: "city", type: "text" },
                  { label: "State", field: "state", type: "text" },
                  { label: "Zip", field: "zip", type: "text" },
                  { label: "About", field: "about", type: "text" },
                  { label: "Skills", field: "skills", type: "text" },
                ].map(({ label, field }) => (
                  <div className="d-flex align-items-center mb-3 gap-3" key={field}>
                    <label className="m-0 text-purple" style={{ width: "150px" }}>
                      {label}
                    </label>
                    <InputText
                      className="flex-grow-1"
                      value={(employeeFormData as any)[field]}
                      onChange={(e) =>setEmployeeFormData({...employeeFormData,[field]: e.target.value,})}
                    />
                  </div>
                 ))} 
                 <div className="d-flex align-items-center mb-3 gap-3">
                  <label className="m-0 text-purple" style={{ width: "150px" }}>
                    Department
                  </label>
                  <Dropdown
                     className="flex-grow-1"
                     value={employeeFormData.departmentId}
                     options={departments}
                     optionLabel="departmentName"
                     optionValue="id"
                     onChange={(e) => setEmployeeFormData({...employeeFormData,departmentId: e.value,})}
                     placeholder="Select a Department"
                   />
                 </div>
                 <div className="d-flex justify-content-end gap-2 mt-4">
                    <PrimeButton
                     label="Cancel"
                     className="alexandria-btn secondary-btn"
                     onClick={() => setEditFormVisible(false)}
                    />
                    <PrimeButton
                      label="Submit"
                      className="alexandria-btn primary-btn"
                     onClick={(e) => submitEmployeeForm(e)}
                    />
                 </div>
            </form>
         </Dialog>
        </div>
      </div>
    </div>
  );
}
